import React from 'react';
import { 
    getWaveHeightClass, 
    getWaveIndicator, 
    getWavePeriodClass, 
    DirectionArrowSVG,
    getWindSpeedClass, 
    getWindIndicator,
    getDirectionText
} from '../../../utils/helpers';
import Loader from '../../common/Loader';
import ScoreCountLive from '../../common/ScoreCountLive';
import Rating from '../../../utils/Rating';
import ViewLink from '../../buttons/ViewLink';

const LiveDataTable = ({spot, liveData}) => {

    if(!spot){
        return <></>
    }

    

    const renderRating = () => {
        const {preferred_wave_height_min, preferred_wave_height_max, preferred_swell_period_min, preferred_swell_period_max, preferred_wind_speed_min, preferred_wind_speed_max, preferred_wind_direction, preferred_swell_direction} = spot;

        if(!preferred_wave_height_min && !preferred_wave_height_max && !preferred_swell_period_min && !preferred_swell_period_max && !preferred_wind_speed_min && !preferred_wind_speed_max && !preferred_wind_direction && !preferred_swell_direction){
            return <></>
        }

        const {current} = liveData;

        const rating = new Rating({
            waveheight: current.wave_height,
            swellperiod: current.swell_wave_period,
            swelldirection: current.swell_wave_direction,
            windspeed: current.wind_speed_10m,
            winddirection: current.wind_direction_10m
        }, {
            preferred_wave_height_min,
            preferred_wave_height_max,
            preferred_swell_period_min,
            preferred_swell_period_max,
            preferred_wind_speed_min,
            preferred_wind_speed_max,
            preferred_wind_direction,
            preferred_swell_direction
        })

        return (
            <tr className="">
                <td className="px-3" colSpan="6">
                    <ScoreCountLive score={rating.score} />
                </td>
            </tr>
        )
    }

    const renderTableBody = () => {

        if(!liveData){
            return (
                <tbody className="divide-y divide-custom-charcoal/50">
                    <tr>
                        <td className="pl-2 pb-1 pt-2 text-center" colSpan="6">
                            <Loader size="md" text="Fetching live data..." />
                        </td>
                    </tr>
                </tbody>
            )
        }

        const {current} = liveData;        

        return (
            <>
            <tbody className="divide-y divide-custom-charcoal/50">
                {renderRating()}
                <tr>
                    <td className="pl-2 pb-1 pt-2 text-center" valign='bottom'>
                        <div className="inline-flex flex-col items-center justify-end gap-1 h-[50px]">
                            <div className="flex justify-center">{getWaveIndicator(current.wave_height)}</div>
                            <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${getWaveHeightClass(current.wave_height)}`}>
                                {current.wave_height?.toFixed(1)}m
                            </div>
                        </div>
                    </td>
                    <td className="pl-2 pb-1 pt-2 text-center" valign='bottom'>
                        <div className="inline-flex flex-col items-center justify-end gap-1 h-[50px]">
                            <div className="flex justify-center">{getWaveIndicator(current.swell_wave_height)}</div>
                            <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${getWaveHeightClass(current.swell_wave_height)}`}>
                                {current.swell_wave_height?.toFixed(1)}m
                            </div>
                        </div>
                    </td>
                    <td className="py-1 text-center" valign='bottom'>
                        <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${getWavePeriodClass(current.swell_wave_period)}`}>
                            {Math.round(current.swell_wave_period)}s
                        </div>
                    </td>
                    <td className="py-1 text-center">
                        <div className="inline-block min-w-[30px] text-center">
                            <div className="flex flex-col items-center justify-end gap-1 h-[50px]">
                                <DirectionArrowSVG degrees={current.swell_wave_direction} size={24} color="#13a4ec" />
                                <div className="text-xs text-white/60">{getDirectionText(current.swell_wave_direction)}</div>
                            </div>
                        </div>
                    </td>
                    <td className="py-1 text-center">
                        <div className="inline-flex flex-col items-center justify-end gap-1 h-[50px]">
                            <div className="flex justify-center">{getWindIndicator(current.wind_speed_10m)}</div>
                            <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${getWindSpeedClass(current.wind_speed_10m)}`}>
                                {Math.round(current.wind_speed_10m)}km
                            </div>
                        </div>
                    </td>
                    <td className="py-1 text-center">
                        <div className="inline-block min-w-[30px] text-center">
                            <div className="flex flex-col items-center justify-end gap-1 h-[50px]">
                                <DirectionArrowSVG degrees={current.wind_direction_10m} size={24} color="#fed900" />
                                <div className="text-xs text-white/60">{getDirectionText(current.wind_direction_10m)}</div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th colSpan="2" className="text-xs font-medium text-white/60 text-center">Wave</th>
                    <th colSpan="2" className="text-xs font-medium text-white/60 text-center">Swell</th>
                    <th colSpan="2" className="text-xs font-medium text-white/60 text-center">Wind</th>
                </tr>
            </tfoot>
            </>
        )
    }

    return (
        <div className="mt-3 mb-10">
            <div className="bg-custom-charcoal rounded-lg p-2 overflow-x-auto">                    
                <table className="forecast-table w-full text-left border-collapse sm:table-fixed">
                    <thead>
                        <tr>
                            <th colSpan="6" className=" font-medium text-white ">
                                <div className='flex justify-between items-center gap-3 px-3 py-1'>
                                    <span className='whitespace-nowrap text-xs'>{spot.name}</span>
                                    <ViewLink to={spot.id} className="ml-4 text-xs whitespace-nowrap">View →</ViewLink>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    {renderTableBody()}
                    
                </table>
                
            </div>
        </div>
    )
}

export default LiveDataTable;